import React, {Fragment, useEffect, useState} from "react";

// reactstrap components
import {
    Button,
    Card,
    CardFooter,
    CardHeader,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText, Modal,
    Row,
    Table, UncontrolledTooltip,
} from "reactstrap";
// layout for this page
// core components
import SimpleHeader from "components/Headers/SimpleHeader.js";
import PaginationWrapper from "../components/pagination";
import {paginate, telWithCommas} from "../../../utils";
import useHistoryState from "../../../common/useHistoryState";
import moment from "moment";
import {useHistory} from "react-router";
import snsService from "./service/sns.service";
import classnames from "classnames";
import AuthService from "../auth/auth.service";
import {Link} from "react-router-dom";

function SnsList() {
    const user = typeof window !== 'undefined' ? AuthService.getCurrentUser() : null;
    const history = useHistory();
    const [pageActive, setPageActive] = useHistoryState(1, 'pageActive');
    const [pageCount, setPageCount] = useHistoryState(1, 'pageCount');
    const [data, setData] = useHistoryState([], 'data');
    const [diff, setDiff] = useHistoryState('', 'diff');
    const [searchCurrent, setSearchCurrent] = useHistoryState(false, 'searchCurrent');
    const [search, setSearch] = useHistoryState('', 'search');
    // console.log('123',user)

    const render = () => {
        let option = { };
        if (search) {
            option.search = search;
        }
        if (pageCount) {
            option.page = pageActive;
        }
        snsService.list({ page: pageActive, search })
            .then((res) => {
                if (res.code === 200) {
                    console.log(res);
                    setPageCount(res.list.count);
                    // setData(paginate(res.centers.rows, pageActive, 11));
                    setData(res.list.rows);
                }
            });
    };

    useEffect(() => {
        render();
    }, [search, pageActive, pageCount]);

    return (
        <>
            <SimpleHeader name="Tables" parentName="Tables" />
            <Container className="mt--6" fluid>
                <Row>
                    <div className="col">
                        <Card>
                            <CardHeader className="border-0">
                                <Row className="py-3">
                                    <Col xs="11">
                                        <Form>
                                            <Row>
                                                <Col xs="3">
                                                    <label className=" form-control-label py-2">
                                                    </label>
                                                    <FormGroup>
                                                        <InputGroup
                                                            className={classnames("input-group-merge", {
                                                                focused: searchCurrent,
                                                            })}
                                                        >
                                                            <InputGroupAddon addonType="prepend">
                                                                <InputGroupText>
                                                                    <i className="fas fa-search" />
                                                                </InputGroupText>
                                                            </InputGroupAddon>
                                                            <Input
                                                                placeholder="센터명으로 검색"
                                                                type="text"
                                                                value={search}
                                                                onChange={(e) => setSearch(e.target.value)}
                                                                onFocus={(e) => setSearchCurrent(true)}
                                                                onBlur={(e) => setSearchCurrent(false)}
                                                            />
                                                        </InputGroup>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="6">
                                        <h3 className="mt-2">
                                            SNS관리
                                        </h3>
                                    </Col>
                                    {/*{user?.role === 'center' ? null : (*/}
                                    {/*  <Col className="text-right">*/}
                                    {/*      <Button*/}
                                    {/*          color="default"*/}
                                    {/*          onClick={(e) => history.push('/admin/centerForm')}*/}
                                    {/*      >*/}
                                    {/*          등록하기*/}
                                    {/*      </Button>*/}
                                    {/*  </Col>*/}
                                    {/*)}*/}
                                </Row>
                            </CardHeader>

                            <Table className="align-items-center table-flush" responsive striped>
                                <thead className="thead-light">
                                    <tr>
                                        <th className="text-center">NO.</th>
                                        <th className="text-center">등록날짜</th>
                                        <th className="text-center">제목</th>
                                        <th className="text-center">좋아요</th>
                                        <th className="text-center">조회수</th>
                                        <th className="text-center">댓글수</th>
                                        <th className="text-center">상세</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, i) => {
                                        return [
                                            <Fragment key={i}>
                                                <tr>
                                                    <td className="text-center">
                                                        {item.id}
                                                    </td>
                                                    <td className="text-center">
                                                        {item.createdAt}
                                                    </td>
                                                    <td className="text-center">
                                                        {item.title}
                                                    </td>
                                                    <td className="text-center">
                                                        {item.wishCount}
                                                    </td>
                                                    <td className="text-center">
                                                        {item.viewCount}
                                                    </td>
                                                    <td className="text-center">
                                                        {item.commentCount}
                                                    </td>
                                                    <td className="text-center">
                                                        <Link
                                                            className="text-center"
                                                            to={'/admin/centerDetail/' + item.id}
                                                        >
                                                            <i id={"tooltip" + i} className="fas fa-user-edit" />
                                                        </Link>
                                                        <UncontrolledTooltip
                                                            delay={0}
                                                            target={"tooltip" + i}
                                                        >
                                                            상세 보기
                                                        </UncontrolledTooltip>
                                                    </td>
                                                </tr>
                                            </Fragment>
                                        ];
                                    })}
                                </tbody>
                            </Table>

                            <CardFooter className="py-4">
                                <PaginationWrapper
                                    isActive={pageActive}
                                    pageNumber={pageCount}
                                    callback={(page) => setPageActive(page)}
                                    itemPerPage={10}
                                />
                            </CardFooter>
                        </Card>
                    </div>
                </Row>
            </Container>
        </>
    );
}

export default SnsList;
